
import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["input", "preview"]
  static values = { url: String, blogAssetsHost: String, blobPath: String }

  upload() {
    const files = Array.from(this.inputTarget.files)

    files.forEach((file) => {
      this.uploadFile(file)
    })
  }

  uploadFile(file) {
    const upload = new DirectUpload(file, this.urlValue)

    upload.create((error, blob) => {
      if (error) {
        console.error("Upload failed:", error)
        return
      }

      this.displayUploadedFile(blob)
    })
  }

  displayUploadedFile(blob) {
    const img = document.createElement("img")
    const blobUrl = `${this.blogAssetsHostValue}/${this.blobPathValue}/${blob.signed_id}/${blob.filename}`

    img.src = blobUrl
    img.alt = blob.filename
    img.className = "uploaded-asset h-50 w-50 mb-2"
    img.style.width = "165px"
    img.style.height = "auto"

    img.setAttribute("data-action", "mouseenter->clipboard#addOverlay click->clipboard#copy")
    img.setAttribute("data-clipboard-content-param", blobUrl)

    this.previewTarget.appendChild(img)
  }
}
